<template>
    <div>
        <div class="items">
            <div class="item card-white mb-3" :class="{ 'margin-200-top': status.complete }">
                <form id="ContactForm" ref="contact_form" class="contact-form" action="javascript:" v-on:submit.prevent="submit">

                    <div v-if="!status.complete">
                        <!-- firstname -->
                        <firstname></firstname>

                        <!-- lastname -->
                        <lastname></lastname>

                        <!-- email and phone -->
                       <div class="group">
                           <label>Email*</label>
                           <input type="text" class="validation" v-bind:class="{ '-invalid': validation.email }" v-model="fields.email" v-on:keyup="validation.email = null" @focus="recaptcha">
                           <div class="error-message" v-for="message in validation.email">{{ message }}</div>
                       </div>

                        <div class="group">
                            <label for="Phone">Phone*</label>
                            <input type="text" class="validation" v-bind:class="{ '-invalid': validation.phone }" name="phone" id="Phone" v-model="fields.phone" v-on:keyup="validation.phone = null">
                            <div class="error-message" v-for="message in validation.phone">{{ message }}</div>
                        </div>

                        <!-- select: country -->
                        <div class="group">
                            <label for="Country">Country*</label>
                            <select id="Country" class="validation selectOptGroup" v-bind:class="{ '-invalid': validation.country }" @change="validation.country = null;" v-model="fields.country">
                                <option selected disabled value="">Choose one</option>
                                <option value="United States">United States</option>
                                <option value="Canada">Canada</option>
                            </select>
                            <div class="error-message" v-for="message in validation.country">{{ message }}</div>
                        </div>

                        <!-- Help us get to know you -->
                        <div class="group" >
                            <label for="SupportTopic">Help us get to know you:*</label>
                            <select id="SupportTopic" class="validation selectOptGroup" v-bind:class="{ '-invalid': validation.support_topic }" @change="updateView" v-model="fields.support_topic">
                                <option selected disabled value="">Choose One</option>
                                <option data-nextstep="[1]" value="I work at a Home Medical Equipment provider (HME or DME)">I work at a home medical equipment provider (HME or DME)</option>
                                <option data-nextstep="[2]" value="I work at a sleep lab">I work at a sleep lab</option>
                                <option data-nextstep="[3]" value="I use a ResMed product">I use a ResMed product</option>
                                <option data-nextstep="[3]" value="I'm researching ResMed products for my own use">I'm researching ResMed products for my own use</option>
                                <option data-nextstep="[3]" value="I'm a family member/caregiver of someone using ResMed products">I'm a family member/caregiver of someone using ResMed products</option>
                                <option data-nextstep="[1]" value="Other business professional">Other business professional</option>
                            </select>
                            <div class="error-message" v-for="message in validation.support_topic">{{ message }}</div>
                        </div>

                        <!-- checkbox: agree to terms and conditions -->
                        <div class="group">
                            <!--<terms-and-conditions></terms-and-conditions>-->
                        </div>

                        <!-- textarea: message / comments -->
                        <!--<message>-->
                        <!--<label>Message</label>-->
                        <!--</message>-->
                        <div v-show="status.step.indexOf(1) != -1">
                            <div class="group">
                                <label for="SupportHome">Which topic can we help you with?*</label>
                                <select id="SupportHome" class="validation selectOptGroup" v-bind:class="{ '-invalid': validation.support_home }" @change="validation.support_home = null;" v-model="fields.support_home">
                                    <option selected disabled value="">Choose one</option>
                                    <option value="Ordering / Order Status">Ordering and order status</option>
                                    <option value="RMA/Returns">RMA/returns</option>
                                    <option value="Billing">Billing</option>
                                    <option value="Product Support">Product support</option>
                                    <option value="Software Support">Software support</option>
                                    <option value="AirView Support">AirView support</option>
                                    <option value="U-Sleep Support">U-Sleep support</option>
                                    <option value="Other Support">Other support</option>
                                </select>
                                <div class="error-message" v-for="message in validation.support_home">{{ message }}</div>
                            </div>
                        </div>
                        <div v-show="status.step.indexOf(2) != -1">
                            <div class="group">
                                <label for="SupportSleepLab">Which topic can we help you with?*</label>
                                <select id="SupportSleepLab " class="validation selectOptGroup" v-bind:class="{ '-invalid': validation.support_sleep_lab }" @change="updateView" v-model="fields.support_sleep_lab">
                                    <option selected disabled value="">Choose one</option>
                                    <option data-nextstep="[2]" value="Ordering and Order Status">Ordering and order status</option>
                                    <option data-nextstep="[2]" value="Returns">Returns</option>
                                    <option data-nextstep="[2]" value="Billing">Billing</option>
                                    <option data-nextstep="[2]" value="Product Support">Product support</option>
                                    <option data-nextstep="[2]" value="Software Support">Software support</option>
                                    <option data-nextstep="[2]" value="Other RSVP Support">Other RSVP support</option>
                                </select>
                                <div class="error-message" v-for="message in validation.support_sleep_lab">{{ message }}</div>
                            </div>
                        </div>
                        <div v-show="status.step.indexOf(3) != -1">
                            <div class="group">
                                <label for="ProductSegment">Which product category can we help with?</label>
                                <select id="ProductSegment" class="validation selectOptGroup" v-bind:class="{ '-invalid': validation.product_segment }" @change="updateView" v-model="fields.product_segment">
                                    <option selected disabled value="">Choose one</option>
                                    <option data-nextstep="[3,4]" value="Sleep apnea, CPAP, or myAir">Sleep apnea, CPAP, or myAir</option>
                                    <option data-nextstep="[3,6]" value="Portable Oxygen">Portable Oxygen</option>
                                    <option data-nextstep="[3,6]" value="Ventilators">Ventilators</option>
                                    <option data-nextstep="[3,6]" value="Other Support">Other support</option>
                                </select>
                                <div class="error-message" v-for="message in validation.product_segment">{{ message }}</div>
                            </div>
                        </div>
                        <div v-show="status.step.indexOf(4) != -1">
                            <div class="group">
                                <label for="ProductRequest">What’s your request about?</label>
                                <select id="ProductRequest" class="validation selectOptGroup" v-bind:class="{ '-invalid': validation.product_request }" @change="updateView" v-model="fields.product_request">
                                    <option selected disabled value="">Choose one</option>
                                    <option data-nextstep="[3,4,5]" value="myAir Login and Support">myAir login and support</option>
                                    <option data-nextstep="[3,4,6]" value="Adjusting to CPAP therapy">Adjusting to CPAP therapy</option>
                                    <option data-nextstep="[3,4,6]" value="Mask discomfort and troubleshooting">Mask discomfort and troubleshooting</option>
                                    <option data-nextstep="[3,4,6]" value="Adjusting CPAP machine settings">Adjusting CPAP machine settings</option>
                                    <option data-nextstep="[3,4,6]" value="Cleaning and Maintenance">Cleaning and maintenance</option>
                                    <option data-nextstep="[3,4,6]" value="Where to buy ResMed products">Where to buy ResMed products</option>
                                    <option data-nextstep="[3,4,6]" value="Who is my CPAP equipment store">Who is my CPAP equipment store</option>
                                    <option data-nextstep="[3,4,6]" value="AirMini">AirMini app support</option>
                                    <option data-nextstep="[3,4,6]" value="Other">Other</option>
                                </select>
                                <div class="error-message" v-for="message in validation.product_request">{{ message }}</div>
                            </div>
                        </div>
                        <div v-show="status.step.indexOf(5) != -1">
                            <div class="group">
                                <label for="MyAirTopic">What myAir topic can we help you with?</label>
                                <select id="MyAirTopic" class="validation selectOptGroup" v-bind:class="{ '-invalid': validation.myair_topic }" @change="updateView" v-model="fields.myair_topic">
                                    <option selected disabled value="">Choose one</option>
                                    <option data-nextstep="[3,4,5,6]" value="Login or account issues">Login or account issues</option>
                                    <option data-nextstep="[3,4,5,6]" value="myAir Data">myAir data</option>
                                    <option data-nextstep="[3,4,5,6]" value="myAir Basics">myAir basics</option>
                                    <option data-nextstep="[3,4,5,6]" value="Library">Library</option>
                                    <option data-nextstep="[3,4,5,6]" value="Data Security">Data security</option>
                                    <option data-nextstep="[3,4,5,6]" value="Other">Other</option>
                                </select>
                                <div class="error-message" v-for="message in validation.myair_topic">{{ message }}</div>
                            </div>
                        </div>


                        <div v-show="status.step.indexOf(1) != -1 || status.step.indexOf(2) != -1">
                            <div class="group">
                                <label for="AccountName">Account name*</label>
                                <input type="text" class="validation" v-bind:class="{ '-invalid': validation.account_name }" name="account_name" id="AccountName" v-on:keyup="validation.account_name = null" v-model="fields.account_name">
                                <div class="error-message" v-for="message in validation.account_name">{{ message }}</div>
                            </div>

                            <div class="group">
                                <label for="AccountNumber">Account number</label>
                                <input type="text" class="validation" id="AccountNumber" v-model="fields.account_number">
                            </div>

                            <div class="group">
                                <label for="Address">Street address*</label>
                                <input type="text" class="validation" v-bind:class="{ '-invalid': validation.address }" name="address" id="Address"  v-on:keyup="validation.address = null" v-model="fields.address">
                                <div class="error-message" v-for="message in validation.address">{{ message }}</div>
                            </div>

                            <div class="group">
                                <label for="City">City*</label>
                                <input type="text" class="validation" v-bind:class="{ '-invalid': validation.city }" name="city" id="City"  v-on:keyup="validation.city = null" v-model="fields.city">
                                <div class="error-message" v-for="message in validation.city">{{ message }}</div>
                            </div>

                            <div class="group">
                                <label for="State">State*</label>
                                <input type="text" class="validation" v-bind:class="{ '-invalid': validation.state }" name="state" id="State"  v-on:keyup="validation.state = null" v-model="fields.state">
                                <div class="error-message" v-for="message in validation.state">{{ message }}</div>
                            </div>

                            <div class="group">
                                <label for="Zip">Zip*</label>
                                <input type="text" class="validation" v-bind:class="{ '-invalid': validation.zip }" name="zip" id="Zip" v-model="fields.zip" v-on:keyup="validation.zip = null">
                                <div class="error-message" v-for="message in validation.zip">{{ message }}</div>
                            </div>

                        </div>

                        <div v-show="status.step.indexOf(1) != -1 || status.step.indexOf(2) != -1 || status.step.indexOf(6) != -1" class="group"  v-bind:class="{ 'errored': validation.description }">
                            <label for="Description">Briefly describe your inquiry:</label>
                            <textarea name="description" id="Description"  v-on:keyup="validation.description = null" v-model="fields.description"></textarea>
                            <div class="error-message" v-for="message in validation.description">{{ message }}</div>
                        </div>

                        <div class="g-recaptcha"
                            v-bind:data-callback="'recaptcha'"
                            v-bind:data-sitekey="'6LffqKIZAAAAAMrS6WHV81yXC8iS8rRaKhh7T_Pg'"
                            v-bind:data-size="'invisible'">
                        </div>
                        <!-- 6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI -->

                        <div v-if="validation.error" class="text-center py-2"><strong v-html="validation.error"></strong></div>
                        <submit-confirmation v-else></submit-confirmation>

                        <!-- submit, validation and confirmation -->
                        <!--<submit-confirmation></submit-confirmation>-->
                    </div>

                    <!-- confirmation message -->
                    <div v-else class="thankyou_message text-center">
                        <h4>Thank you for contacting us.</h4>
                        <p><strong>We are committed to responding to each and every inquiry. However, we are currently experiencing a higher volume of emails than usual and it may take a few days to respond. We appreciate your patience.</strong></p>

                        <p v-if="status.step.includes(3)"><strong>Note to consumers:</strong> ResMed is an equipment manufacturer and does not sell directly to patients. We are legally prohibited from answering any therapy, insurance, or pricing-related questions.</p>

                        <p>All submissions to ResMed must be in accordance to ResMed's <a href="/terms-of-use/">terms of use</a> and <a href="/privacy/">privacy policy</a>.</p>
                        <p>For product warranty information, please visit our <a href="/product-warranty-information/">Product Warranty page</a>.</p>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import { scroll } from '../../mixins/index';
    import fields from './fields/index';
    import recaptcha from '../../mixins/recaptcha';

    let fillable = {
        recaptcha: '',
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        country: '',
        support_topic: '',
        support_home: '',
        support_sleep_lab: '',
        product_segment: '',
        myair_topic: '',
        product_request: '',
        account_name: '',
        account_number: '',
        address: '',
        city: '',
        state: '',
        zip: ''
    }

    export default {
        data() {
            return {
                form: {
                    name: '',   // form name
                    origin: ''  // form origin ( page )
                },
                status: {
                    idle: null,
                    step: [],
                    last_step: [],
                    errors: false,
                    complete: false,
                },
                response: {
                    type: '', // validation or confirmation
                    message: '' // response
                },
                fields: { ...fillable },
                validation: {}
            }
        },
        components: {
          ... fields
        },
        mixins: [ scroll, recaptcha ],
        methods: {
            updateView(e) {
                this.validation.support_topic = null
                this.validation.myair_topic = null
                this.validation.product_segment = null
                this.validation.product_request = null
                if (e.target.options[e.target.options.selectedIndex]) {
                    let step = e.target.options[e.target.options.selectedIndex].dataset.nextstep
                    this.status.step = step
                }
            },
            reset() {
                this.status.step = 0;
                return this.fields = {
                    ...fillable
                }
            },
            format(value, key) {
                switch(key) {
                    case 'phone':
                        return this.fields[key] = value.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
                        break;
                }
            },
            validateAccountInfo() {
                if (this.status.step.includes(2) && !this.fields.support_sleep_lab) {
                    this.validation.support_sleep_lab = ['This field is required']
                    this.status.errors = true
                }

                if (this.status.step.includes(1) && !this.fields.support_home) {
                    this.validation.support_home = ['This field is required']
                    this.status.errors = true
                }

                if (!this.fields.account_name) {
                    this.validation.account_name = ['This field is required']
                    this.status.errors = true
                }

                if (!this.fields.address) {
                    this.validation.address = ['This field is required']
                    this.status.errors = true
                }

                if (!this.fields.city) {
                    this.validation.city = ['This field is required']
                    this.status.errors = true
                }

                if (!this.fields.state) {
                    this.validation.state = ['This field is required']
                    this.status.errors = true
                }

                if (!this.fields.zip) {
                    this.validation.zip = ['This field is required']
                    this.status.errors = true
                }
            },
            validateSegmentInfo() {
                if (!this.fields.product_segment) {
                    this.validation.product_segment = ['This field is required']
                    this.status.errors = true
                }
            },
            validateBaseInfo() {
                if (!this.fields.firstname.length) {
                    this.validation.firstname = ['This field is required']
                    this.status.errors = true
                }

                if (!this.fields.lastname.length) {
                    this.validation.lastname = ['This field is required']
                    this.status.errors = true
                }

                let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (!re.test(String(this.fields.email).toLowerCase())) {
                    this.validation.email = ['Please enter your email address in format: yourname@example.com']
                    this.status.errors = true
                }

                if (!this.fields.phone) {
                    this.validation.phone = ['This field is required']
                    this.status.errors = true
                }

                if (!this.fields.country) {
                    this.validation.country = ['This field is required']
                    this.status.errors = true
                }

                if (!this.fields.support_topic) {
                    this.validation.support_topic = ['This field is required']
                    this.status.errors = true
                }
            },
            submit(event) {
                let data = new FormData();

                this.validation = {}
                if (this.status.step.includes(1) || this.status.step.includes(2)) {
                    this.validateAccountInfo()
                }

                if (this.status.step.includes(3)) {
                    this.validateSegmentInfo()
                }

                this.validateBaseInfo()

                if (this.status.errors) {
                    this.status.errors = false;
                    return; // console.log(this.validation)
                }

                // form attributes
                data.append('form[name]', this.form.name);
                data.append('form[origin]', this.form.origin);

                // append fields
                for ( let prop in this.fields ) {
                    data.append(prop, this.fields[prop]);
                }

                // on before send
                axios.interceptors.request.use((config) => {
                    this.status.idle = true;
                    this.response.message = '';
                    this.validation = {};

                    return config;
                });

                // send post request
                axios({
                    method: 'post',
                    url: '/wp-content/themes/resmed/src/js/components/forms/form-contact-process.php',
                    config: {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    },
                    data: data
                })
                .then((response) => {
                    let data = response.data;
                    this.status.idle = null;

                    if ( 'error' in data ) {
                        this.validation = { error: data.error };
                    }
                    else {
                        this.status.complete = true;
                        this.$parent.complete = this.status.complete;

                        this.scroll({
                            to: `.component-d0b82bdc`,
                            duration: 1200
                        });
                    }
                });
            },
            addOptGroup() {
                if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1 ) {
                    let optSelect = document.getElementsByClassName('selectOptGroup');
                    //$(".selectOptGroup optgroup").remove();
                    for (var i = 0; i < optSelect.length; i++) {
                        let optItem = document.createElement("optgroup");
                        optSelect[i].add(optItem);
                    }
                }
            }
        },
        created() {
            this.form.name = this.$parent.name;
            this.form.origin = this.$parent.origin;
        },
        mounted(){
            this.addOptGroup();
        }
    }
</script>
